import Vue from "vue";
import axios from "axios";
import { inject, provide, reactive, toRefs } from "@vue/composition-api";

export const state = reactive({});

export const actions = {
    fetchSupplierType(account_id, supplier_type_id) {
        return new Promise((resolve, reject) => {
            let url = Vue.config.url_prefix + "/api/a/{0}/supplier_types/{1}".format(account_id, supplier_type_id);
            axios
                .get(url)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    saveSupplierType(data) {
        return new Promise((resolve, reject) => {
            let url = "a/{0}/supplier_types".format(data.account_id);
            axios
                .post(url, data)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    saveSupplierTypeOrder(data) {
        return new Promise((resolve, reject) => {
            let url = "a/{0}/supplier_types".format(data.account_id);
            axios
                .patch(url, data)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    deleteSupplierType(account_id, supplier_type_id) {
        return new Promise((resolve, reject) => {
            let url = "a/{0}/supplier_types".format(account_id);
            axios
                .delete(url, { data: { supplier_type_id }})
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    fetchSuppliers(account_id, params) {
        return new Promise(function (resolve, reject) {
            axios
                .get("suppliers", { params: params })
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    fetchSupplier(supplier_id) {
        return new Promise((resolve, reject) => {
            axios
                .get("suppliers/{0}".format(supplier_id))
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    saveSupplier(data) {
        return new Promise((resolve, reject) => {
            axios
                .post("suppliers", data)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    deleteSupplier(supplier_id) {
        return new Promise((resolve, reject) => {
            axios
                .delete("suppliers/{0}".format(supplier_id))
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
};

export const key = Symbol("SupplierModule");

export const provideSupplier = () => {
    provide(key, {
        ...toRefs(state),
        ...actions
    });
};

export default () => inject(key);
